import {
	useAgeValidator,
	useTurkeyConsentValidator,
	useUsernameValidator,
} from '@app/hooks/useValidators';
import {
	BooleanFormControlField,
	FormControlField,
	NumberFormControlField,
} from '../FormField';
import type {FieldProps} from '../FormField';
import {useTranslation} from '@app/hooks/useTranslation';
import type {BoxProps} from '@tempo/core';

export const UsernameField: React.FC<FieldProps<string>> = (props) => {
	const [usernameValidator] = useUsernameValidator();
	const t = useTranslation();
	return (
		<FormControlField
			validate={usernameValidator}
			data-testid="user-name-field"
			label={t('common.label_username')}
			{...props}
		/>
	);
};

export const AgeField: React.FC<FieldProps<string>> = (props) => {
	const [ageValidator] = useAgeValidator();
	const t = useTranslation();
	return (
		<NumberFormControlField
			validate={ageValidator}
			type="number"
			constraint={{min: 0}}
			label={t('common.label_age')}
			{...props}
		/>
	);
};

export const AgeFieldAcquisition: React.FC<FieldProps<string> & BoxProps> = (
	props,
) => {
	const [ageValidator] = useAgeValidator();
	const t = useTranslation();
	return (
		<FormControlField
			validate={ageValidator}
			type="number"
			label={t('common.label_age')}
			{...props}
		/>
	);
};

export const ConsentTurkeyField: React.FC<FieldProps<string>> = (props) => {
	const [consentTurkeyValidator] = useTurkeyConsentValidator();
	return (
		<BooleanFormControlField validate={consentTurkeyValidator} {...props} />
	);
};
